/* eslint react-hooks/exhaustive-deps: "warn" */

import type { CSSProperties } from 'react';

import cn from 'classnames';

import styles from './CompareMatrix.module.scss';

import type { CompareMatrixProps } from './CompareMatrix.types';

export const CompareMatrix = ({ columns, rows, className }: CompareMatrixProps) => {
  const gridStyle = {
    '--compare-columns': `1.15fr repeat(${columns.length}, 1.35fr)`,
  } as CSSProperties;

  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.head} style={gridStyle}>
        <div className={styles.headMetric} />

        {columns.map((column) => (
          <div
            key={column.name}
            className={cn(styles.headCol, column.highlight ? styles.headColHighlight : styles.headColMuted)}
          >
            <span className={styles.headName}>{column.name}</span>
            {column.tag && <span className={styles.headTag}>{column.tag}</span>}
            {column.logo && <span className={styles.headLogo}>{column.logo}</span>}
          </div>
        ))}
      </div>

      {rows.map((row) => (
        <div key={row.metric} className={styles.row} style={gridStyle}>
          <div className={styles.metric}>{row.metric}</div>

          {row.cells.map((cell, index) => (
            <div
              key={cell.text}
              className={cn(
                styles.cell,
                cell.positive && styles.cellPositive,
                cell.positive === false && styles.cellNegative,
              )}
              data-label={columns[index]?.name}
            >
              {cell.positive !== undefined && (
                <span
                  className={cn(styles.mark, cell.positive ? styles.markTick : styles.markCross)}
                  aria-hidden="true"
                >
                  {cell.positive ? '✓' : '✕'}
                </span>
              )}

              {cell.text}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
